import { render } from "./NavbarCashier.vue?vue&type=template&id=4bd8f570&scoped=true"
import script from "./NavbarCashier.vue?vue&type=script&lang=js"
export * from "./NavbarCashier.vue?vue&type=script&lang=js"

import "./NavbarCashier.vue?vue&type=style&index=0&id=4bd8f570&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd8f570"]])

export default __exports__